<script>
	import Modal from '@/Components/ModalFlex.svelte';
	import MarketBets from '@/Partials/Sport/Markets/_MarketBets.svelte';
	import { tick } from 'svelte';

	export let eventToShowBets;
	export let showBetsForMarket;
	export let marketToShowBets;

	const close = async () => {
		showBetsForMarket = false;
		await tick();
		marketToShowBets = undefined;
		eventToShowBets = undefined;
	};
</script>

{#if showBetsForMarket}
	<Modal className="md:w-2/3 lg:w-2/3 mx-2 md:mx-auto" on:close={close}>
		<h2 slot="header" class="pt-2 mb-2 text-xl font-bold text-center">
			Bets for market '{marketToShowBets.name}' in event '{eventToShowBets.name}'
		</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<MarketBets bind:market={marketToShowBets} bind:event={eventToShowBets} />
			<button class="my-4 btn btn-muted" on:click|preventDefault={close}> Close</button>
		</div>
	</Modal>
{/if}
